import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import { CONSULTATION_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import moment from "moment";
import {
  deleteConsultationAction,
  deleteConsultationContractAction,
  downloadConsultationContractAction,
  uploadConsultationContractAction,
} from "../../../redux/actions/consultationsActions";
import { useCustomHook } from "../../../globalComponents/GlobalFunctions/globalFunctions";
import DeleteItemModal from "../../../globalComponents/Modals/DeleteItemModal/DeleteItemModal";
import EduConfirmedCheckbox from "./EduConfirmedCheckbox";
import { RiUpload2Fill } from "react-icons/ri";
import { RiDownload2Fill } from "react-icons/ri";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { Box, Typography } from "@mui/material";

const ConsultationCard = ({
  cellNumber,
  mode,
  setOpenMoreModal,
  data,
  consultation,
}) => {
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const fileInputRef = useRef(null);
  const [currentFile, setCurrentFile] = useState(data?.files?.[0] || null);

  // console.log(data, "data");

  const {
    cancelReasonList,
    knowledgeList,
    constStatusList,
    whereComingList,
    personaList,
    contractTypesList,
  } = useCustomHook();

  const listData = [
    { key: "Təlimçi", value: data?.teacher?.fullName },

    { key: "Mobil nömrə", value: data?.studentPhone },
    { key: "İxtisas", value: data?.course?.name },
    {
      key: "Əlaqə tarixi",
      value: data?.contactDate
        ? moment(data?.contactDate).locale("az").format("DD MMMM YYYY")
        : "",
    },
    {
      key: "Konsultasiya tarixi",
      value: data?.constDate
        ? moment(data?.constDate).locale("az").format("DD MMMM YYYY")
        : "",
    },
    {
      key: "Satış tarixi",
      value: data?.salesDate
        ? moment(data?.salesDate).locale("az").format("DD MMMM YYYY")
        : "",
    },
    { key: "Konsultasiya saatı", value: data?.constTime },
    {
      key: "Status",
      value:
        constStatusList.find((item) => item.key === data.status)?.name || "",
    },
  ];

  // const whereComingName =
  //   whereComingList.find((item) => item?.key === data?.whereComing)?.name || "";

  const cancelReasonName =
    cancelReasonList.find((item) => item?.key === data?.cancelReason)?.name ||
    "";
  const knowledgeListName =
    knowledgeList.find((item) => item?.key === data?.knowledge)?.name || "";

  const updateItem = (modalType) => {
    // console.log("5. updateItem");

    dispatch({
      type: CONSULTATION_MODAL_ACTION_TYPE.GET_CONSULTATION_MODAL,
      payload: {
        data: data,
        openModal: modalType !== "more" ? true : false,
        firstStep: true,
        secondStep: false,
      },
    });
  };
  const deleteItem = () => {
    dispatch(deleteConsultationAction(data._id));
  };
  const openMoreModal = () => {
    updateItem("more");
    setOpenMoreModal(true);
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    dispatch(uploadConsultationContractAction(data._id, formData));
  };

  const openConfirmModal = () => {
    dispatch({
      type: CONSULTATION_MODAL_ACTION_TYPE.OPEN_CONSULTATION_CONFIRM_MODAL,
      payload: {
        data: data,
        openModal: false,
        confirmModal: true,
      },
    });
  };

  const doubleClick = () => {
    updateItem("");
  };

  return (
    <>
      {showDeleteModal && (
        <DeleteItemModal
          setShowDeleteModal={setShowDeleteModal}
          deleteItem={deleteItem}
        />
      )}
      {mode === "desktop" ? (
        <tr onDoubleClick={doubleClick}>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {cellNumber}. {data?.studentName}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">{data?.studentPhone}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {data?.isResubmission ? "Var" : "Yoxdur"}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {data?.createdAt
                  ? moment(data?.createdAt).locale("az").format("DD MMMM YYYY")
                  : ""}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {data?.createdAt
                  ? moment(data?.createdAt).locale("az").format("HH:mm")
                  : ""}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">{data?.worker?.fullName}</div>
            </div>
          </td>
          <td
            style={
              data.previousPriority === 1
                ? { backgroundColor: "#ffced1" }
                : data?.status === "sold"
                  ? { backgroundColor: "#d4ffbf" }
                  : data?.status === "cancelled"
                    ? { backgroundColor: "#ffced1" }
                    : data?.status === "appointed"
                      ? { backgroundColor: "#d2c3fe" }
                      : {}
            }
          >
            <div className="td-con">
              <div className="table-scroll-text">
                {constStatusList.find((item) => item.key === data.status)
                  ?.name || ""}
                {data[
                  constStatusList.find((item) => item.key === data.status)
                    .dateField
                ]
                  ? moment(
                      data[
                        constStatusList.find((item) => item.key === data.status)
                          .dateField
                      ],
                    )
                      .locale("az")
                      .format(" / DD MMMM YYYY")
                  : ""}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {[
                  data?.firstCallAddInfo,
                  data?.wsMessageAddInfo,
                  data?.warmCallAddInfo,
                  data?.coldCallAddInfo,
                  data?.iceCallAddInfo,
                  data?.appointedConsultationAddInfo,
                  data?.salesAddInfo,
                  data?.cancelledAddInfo,
                  data?.addInfo,
                ]
                  .filter(Boolean)
                  .join(" | ")}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {data?.whereComing?.name
                  ? data?.whereComing?.name
                  : data?.externalRequestId
                    ? "Sayt"
                    : ""}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {data?.course?.name || data?.courseNameByExternal}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {data?.goal === "career_change"
                  ? "Yeni peşə/iş tapmaq"
                  : data?.goal === "advance"
                    ? "İşimdə irəliləmək"
                    : data?.goal === "hobby"
                      ? "Maraq/hobbi"
                      : "-"}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {data?.occupation === "jobless"
                  ? "İşsizəm/Yeni məzunam"
                  : data?.occupation === "fulltime"
                    ? "Tam ştat işləyirəm"
                    : data?.occupation === "student"
                      ? "Universitet tələbəsiyəm"
                      : "-"}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {data?.paymentType === "cash"
                  ? "Nağd tam ödəniş (20% endirim ilə)"
                  : data?.paymentType === "installment"
                    ? "Hissəvi / Taksit ilə"
                    : data?.paymentType === "employer"
                      ? "Şirkətim/işəgötürənim ödəyəcək"
                      : data?.paymentType === "not_considering"
                        ? "Hazırda ödənişli təhsil düşünmürəm"
                        : "-"}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {contractTypesList.find(
                  (item) => item.key === data?.contract?.contractType,
                )?.name || ""}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">{data?.fin}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">{data?.seria}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {data?.birthday
                  ? moment(data?.birthday).locale("az").format("DD MMMM YYYY")
                  : ""}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">
                {data?.contract?.contractType === "B2C"
                  ? data?.paymentData.totalAmount
                  : data?.contract?.contractType === "barter"
                    ? 0
                    : data.company?.payment || 0}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">{data?.email}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              {/* <div className="cell-number">{cellNumber}.</div> */}
              <div className="table-scroll-text">{data?.group?.name}</div>
            </div>
          </td>
          <td>
            {(data?.contract?.contractType === "B2C" ||
              data?.contract?.contractType === "B2C-Corporate" ||
              data?.contract?.contractType === "barter") && (
              <div className="td-con">
                <input
                  type="file"
                  accept="application/pdf"
                  ref={fileInputRef}
                  onChange={handleUpload}
                  style={{ display: "none" }}
                />
                {data?.signedContractPath && (
                  <Box
                    sx={{
                      width: "100%",
                      gap: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      fontSize={12}
                      sx={{
                        color: "green",
                        textTransform: "initial",
                      }}
                    >
                      {data?.signedContractPath
                        ? data.signedContractPath?.slice(0, 15) + ".pdf"
                        : "Fayl mövcud deyil"}
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <RiDownload2Fill
                        fill="#462aff"
                        style={{
                          cursor: "pointer",
                          padding: 1,
                          boxSizing: "border-box",
                          fontSize: 24,
                        }}
                        onClick={() => {
                          dispatch(downloadConsultationContractAction(data));
                        }}
                      />
                      <MdOutlineDeleteOutline
                        fill="rgb(237, 68, 78)"
                        style={{
                          cursor: "pointer",
                          padding: 1,
                          boxSizing: "border-box",
                          fontSize: 24,
                        }}
                        onClick={() => {
                          dispatch(deleteConsultationContractAction(data._id));
                        }}
                      />
                    </Box>
                  </Box>
                )}
                {!data?.signedContractPath && (
                  <Box
                    sx={{
                      width: "100%",
                      gap: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography
                        fontSize={12}
                        sx={{
                          color: "gray",
                          textTransform: "initial",
                        }}
                      >
                        Fayl əlavə et
                      </Typography>
                      <RiUpload2Fill
                        fill="gray"
                        style={{
                          cursor: "pointer",
                          padding: 1,
                          boxSizing: "border-box",
                          fontSize: 24,
                        }}
                        onClick={() => fileInputRef.current.click()}
                      />
                    </Box>
                  </Box>
                )}
              </div>
            )}
          </td>{" "}
          <td style={{ backgroundColor: "lightgray" }}>
            <div className="td-con">
              <div className="table-scroll-text" style={{ padding: "0px" }}>
                <EduConfirmedCheckbox data={data} />
              </div>
            </div>
          </td>
          <td>
            <UpdateDeleteModal
              updateItem={updateItem}
              deleteItem={deleteItem}
              data={data}
              openConfirmModal={openConfirmModal}
              openMoreModal={openMoreModal}
              profil={"consultation"}
              state={consultation}
              setShowDeleteModal={setShowDeleteModal}
            />
          </td>
        </tr>
      ) : (
        <div className="content-box">
          <div className="left">
            <h3>{data?.studentName}</h3>
            <ul>
              {listData?.map((item, index) => (
                <li key={index}>
                  <span className="type">{item.key}:</span>
                  <p>{item.value}</p>
                </li>
              ))}
            </ul>
          </div>
          {consultation.power === "only-show" ? (
            <div className="more-content">
              <span onClick={openMoreModal}>Ətraflı</span>
            </div>
          ) : (
            <div className="right">
              <UpdateDeleteModal
                updateItem={updateItem}
                deleteItem={deleteItem}
                data={data}
                openConfirmModal={openConfirmModal}
                state={consultation}
                openMoreModal={openMoreModal}
                profil={"consultation"}
                setShowDeleteModal={setShowDeleteModal}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ConsultationCard;
